import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LinkClick from './icon-link-click.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LinkClick {...validProps} />;
}
SvgComponent.iconName = 'click';

/**
 * @deprecated This is a legacy icon
 */
export const LinkClickIcon = svgIconWrapper(SvgComponent);
